
































import { defineComponent, ref } from "@vue/composition-api";
import useAuthUser from "@/hooks/useAuthUser";
import BaseButton from "@/components/BaseButton";
import BaseConfirm from "@/components/BaseConfirm";
import BaseIcon from "@/components/BaseIcon";

export default defineComponent({
  name: "AiBanner",
  components: { BaseConfirm, BaseButton, BaseIcon },
  setup(_, { root }) {
    const { authUser } = useAuthUser();

    const showConfirm = ref(false);
    const onClick = () => {
      root.$router.push({ name: "aiQuestionary", params: { userId: authUser.value?.id ?? "" } });
    };
    return {
      showConfirm,
      onClick,
    };
  },
});
